/* ---------------------------------------------------------------------------
   BOULDER BLOCK — FREE GIFTS, GUARANTEED BY THE THEME   (v2, 2026-09-22)
   See pdp/free_gift_race.md.

   Tek Labs Gifts & Upsell (Salepify) adds the 3 gifts AND applies its code
   "Limited Time Offer" from an engine that boots 6-16 s after the page. A shopper
   who adds to cart first gets neither, and the app never retries: 109 of 1,977
   Boulder Block orders 09-14 → 09-21 had no gifts and no code (100% correlated).

   v1 (08-28) replaced the app and was reverted. v2 does not fight the app, it
   MIRRORS it: the same variant, the same line property, the same code. Shopify
   merges identical lines, and the app treats lines carrying its property as its
   own, so whichever actor is first, the cart ends up the same.

   The 100%-off is Tek Labs' Function discount "Limited Time Offer" (code,
   combines with everything). Measured on live carts 2026-09-22:
     - gifts with the property but WITHOUT the code are CHARGED
     - the code zeroes exactly one of each gift per Boulder Block; extras are
       split off and CHARGED  → gift qty must equal block qty, never more
     - with no Boulder Block the code is "not applicable" and gifts are CHARGED
       → gift lines must leave the cart with the last block
   So this keeps, after every cart write: each gift = block count, the code on
   the cart while a block is in it, and never touches a gift SKU the shopper
   bought on its own (no property = a paid line).
--------------------------------------------------------------------------- */
(function () {
  "use strict";
  var VERSION = "2.1.0";
  // "test": only sessions opened with ?cg_gifts=1 · "on": every visitor · "off": nobody
  var MODE = "on";

  var BLOCK = 50633696051526;
  var GIFTS = [55110017417542, 49214012195142, 56856060887366];
  var PROP  = "_salepify-advanced-fg", RULE = "17946";
  var CODE  = "Limited Time Offer";
  var MAX_WRITES = 8;                        // per page view — a guard against ping-pong

  try {
    var q = new URLSearchParams(location.search).get("cg_gifts");
    if (q === "1" || q === "0") sessionStorage.setItem("cg_gifts", q);
    var s = sessionStorage.getItem("cg_gifts");
    if (s === "0") MODE = "off";
    else if (s === "1" && MODE === "test") MODE = "on";
  } catch (e) {}
  var diag = window.__cgGifts = { version: VERSION, mode: MODE, writes: 0, log: [] };
  if (MODE !== "on") return;

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
  var origFetch = window.fetch.bind(window);
  var running = false, again = false, againFull = false, timers = [];

  function note(m) { diag.log.push(Math.round(performance.now()) + "ms " + m); }
  function api(path, body) {
    return origFetch(root + path, body
      ? { method: "POST", credentials: "same-origin",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify(body) }
      : { credentials: "same-origin", headers: { Accept: "application/json" } })
      .then(function (r) { if (!r.ok) throw new Error(path + " " + r.status); return r.json(); });
  }
  function isOurs(item) {
    return GIFTS.indexOf(item.variant_id) > -1 && item.properties && String(item.properties[PROP]) === RULE;
  }

  /* full=false is the quick pass right after a cart write: it only ADDS what is
     missing, trims extras and applies the code. It never clears gift lines from a
     cart with no block, because the app adds its gifts in parallel with the block
     and they briefly land first, and a slow block add can take >3 s (live test
     09-22). full=true (load, the 8 s re-check, checkout click) also clears gifts left behind in a block-less cart, where the
     code is "not applicable" and they would be charged. */
  function sync(why, full) {
    if (running) { again = true; againFull = againFull || !!full; return; }
    if (diag.writes >= MAX_WRITES) { note("write cap reached, stopping (" + why + ")"); return; }
    running = true;
    api("cart.js").then(function (cart) {
      var blocks = 0, byVariant = {};
      cart.items.forEach(function (i) {
        if (i.variant_id === BLOCK) blocks += i.quantity;
        if (isOurs(i)) (byVariant[i.variant_id] = byVariant[i.variant_id] || []).push(i);
      });

      var add = [], updates = {}, touched = false;
      GIFTS.forEach(function (v) {
        var lines = byVariant[v] || [];
        var have = lines.reduce(function (n, l) { return n + l.quantity; }, 0);
        if (have === blocks && lines.length <= 1) return;
        if (blocks === 0 && !full) return;
        if (!lines.length) {
          if (blocks > 0) add.push({ id: v, quantity: blocks, properties: (function () { var p = {}; p[PROP] = RULE; return p; })() });
          return;
        }
        lines.forEach(function (l, n) { updates[l.key] = n === 0 ? blocks : 0; touched = true; });
      });

      var codes = (cart.discount_codes || []).map(function (d) { return d.code; });
      var hasCode = codes.some(function (c) { return String(c).toLowerCase() === CODE.toLowerCase(); });
      var needCode = blocks > 0 && !hasCode;

      if (!add.length && !touched && !needCode) { note("ok (" + why + ") blocks=" + blocks); return; }
      diag.writes++;
      note("fix (" + why + ") blocks=" + blocks + " add=" + add.length + " qty=" + Object.keys(updates).length + " code=" + needCode);

      var p = add.length ? api("cart/add.js", { items: add }) : Promise.resolve();
      return p.then(function () {
        var body = {};
        if (touched) body.updates = updates;
        if (needCode) body.discount = codes.concat([CODE]).join(",");
        return Object.keys(body).length ? api("cart/update.js", body) : null;
      }).then(refreshDrawer);
    }).catch(function (e) { note("error " + (e && e.message)); })
      .then(function () {
        running = false;
        if (again) { var f = againFull; again = false; againFull = false; sync("queued", f); }
      });
  }

  /* The drawer does not redraw for writes it didn't make (live test 09-22: cart held
     8 items, drawer still said "2 items"). Re-render it the way the theme does:
     the Section Rendering API for the sections the drawer itself declares. */
  function refreshDrawer() {
    try {
      var d = document.querySelector("cart-drawer");
      if (!d || !d.getSectionsToRender || !d.getSectionInnerHTML) return;
      var secs = d.getSectionsToRender();
      return origFetch(root + "?sections=" + secs.map(function (x) { return x.id; }).join(","), { credentials: "same-origin" })
        .then(function (r) { return r.json(); })
        .then(function (html) {
          secs.forEach(function (x) {
            var el = x.selector ? document.querySelector(x.selector) : document.getElementById(x.id);
            if (el && html[x.id] != null) el.innerHTML = d.getSectionInnerHTML(html[x.id], x.selector);
          });
        }).catch(function (e) { note("drawer refresh failed " + (e && e.message)); });
    } catch (e) { note("drawer refresh failed " + (e && e.message)); }
  }

  /* after a cart write that isn't ours: act almost at once, then re-check twice.
     Do NOT wait for the app: window.tlFreeGiftOffer exists long before the app
     works (live test 09-22: present at 0.8 s, no gifts by 5.4 s), and when it does
     add, its gifts sit CHARGED until its code lands (~15 s). A double add merges
     into one line (same variant + property); the re-checks set it back to 1 per block. */
  function afterWrite(src) {
    timers.forEach(clearTimeout);
    timers = [setTimeout(function () { sync(src, false); }, 300),
              setTimeout(function () { sync(src + " recheck3s", false); }, 3000),
              setTimeout(function () { sync(src + " recheck8s", true); }, 8000)];
  }

  var WRITE = /\/cart\/(add|change|update)(\.js)?(\?|$)/;
  window.fetch = function (input) {
    var url = typeof input === "string" ? input : (input && input.url) || "";
    var p = origFetch.apply(window, arguments);
    if (WRITE.test(url)) p.then(function () { afterWrite("fetch"); }).catch(function () {});
    return p;
  };
  var xo = XMLHttpRequest.prototype.open, xs = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, u) { this.__cgUrl = u; return xo.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function () {
    if (typeof this.__cgUrl === "string" && WRITE.test(this.__cgUrl)) {
      this.addEventListener("load", function () { afterWrite("xhr"); });
    }
    return xs.apply(this, arguments);
  };

  /* a head start when they head for checkout (never blocks the click) */
  document.addEventListener("pointerdown", function (e) {
    var t = e.target && e.target.closest && e.target.closest('[name="checkout"], a[href*="/checkout"], button[form*="cart"]');
    if (t) sync("checkout-click", true);
  }, true);

  /* repair a cart that arrives already missing its gifts (a reload, a recovery link) */
  function boot() { sync("load", true); setTimeout(function () { sync("load recheck", true); }, 7000); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();
  window.addEventListener("pageshow", function (e) { if (e.persisted) sync("bfcache", true); });
})();
